import React, { useCallback, useEffect, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Locize from 'i18next-locize-backend';
import { Menu, Icon, Dropdown, Button } from 'antd';
import { DropDownContainer, MenuItem } from './styles';
import { fetchUserDetails } from '../../utils/services/authAPI';
import { updateLanguagePreference } from '../../utils/services/languageApi';
import { AppStoreContext } from '../../context/appStoreContext';
import { locizeOptions } from '../../i18n';

const Changelang = () => {
  const { t, i18n } = useTranslation();
  const { userDetails, setUserDetails } = useContext(AppStoreContext);
  const [languages, setLanguages] = useState({});
  const locize = new Locize(locizeOptions);

  useEffect(() => {
    (async () => {
      let response = await locize.getLanguages();
      setLanguages(response);
    })();
  }, []);

  useEffect(() => {
    if (userDetails && userDetails.languageCode && userDetails.languageCode !== '') {
      i18n.changeLanguage(userDetails.languageCode);
    }
  }, [userDetails]);

  const changeLanguage = async lng => {
    i18n.changeLanguage(lng);
    let response = await updateLanguagePreference(lng);
    if (response && response?.errors?.length === 0) {
      const res = await fetchUserDetails();
      if (res && res.data) {
        setUserDetails(res.data);
      }
    }
  };

  const menu = useCallback(() => {
    return (
      <Menu>
        {Object.keys(languages).map((keyName, i) => (
          <Menu.Item onClick={() => changeLanguage(keyName)}>
            <MenuItem active={keyName === i18n.language}>
              {languages[keyName].nativeName}
              {keyName === i18n.language && <Icon type="check" />}
            </MenuItem>
          </Menu.Item>
        ))}
      </Menu>
    );
  }, [languages, i18n.language]);

  return (
    <DropDownContainer>
      <Dropdown overlay={menu}>
        <Button>
          {i18n.language} <Icon type="global" /> <Icon type="down" />
        </Button>
      </Dropdown>
    </DropDownContainer>
  );
};

export default Changelang;
